module.exports = __webpack_public_path__ + "img/background-visite.26554204.jpg";